import React from 'react';
import { TextField } from '@mui/material';
import { Button } from 'components/index';

interface AddNoteProps {
  newNote: string;
  setNewNote: (note: string) => void;
  handleAddNote: () => Promise<void>;
  handleCancelAddNote: () => void;
  isAdding: boolean;
  isLocked: boolean | undefined;
}

export const AddNote: React.FC<AddNoteProps> = ({ newNote, setNewNote, handleAddNote, handleCancelAddNote, isAdding, isLocked }) => {
  return (
    <div style={{ marginBottom: '20px', padding: '10px', background: '#f3f3f3', borderRadius: '5px' }}>
      <TextField
        label='Add Note'
        multiline
        rows={4}
        value={newNote}
        onChange={e => {
          const inputValue = e.target.value;
          if (inputValue.trim().length > 0 || inputValue === '') {
            setNewNote(inputValue);
          }
        }}
        fullWidth
        variant='outlined'
        margin='normal'
      />
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '10px' }}>
        <Button
          variant='outlined'
          color='error'
          onClick={handleCancelAddNote}
          style={{ marginRight: '10px' }}
          disabled={isLocked || isAdding}
        >
          Cancel
        </Button>
        <Button
          variant='contained'
          color='primary'
          onClick={handleAddNote}
          loading={isAdding}
          disabled={isLocked || isAdding || newNote.trim().length === 0}
        >
          Add Note
        </Button>
      </div>
    </div>
  );
};
